import Const from 'constants';
import Action from 'actions';

let OpposingPitchers = {
    setOpposingPitchersFromStorage(data) {
        return {
            type: Const.OPPOSING_PITCHERS_SET_DATA_FROM_STORAGE,
            data,
        };
    },
    setOpposingPitchersIsAllowed(isAllowed) {
        return (dispatch) => {
            dispatch({
                type: Const.OPPOSING_PITCHERS_SET_IS_ALLOWED,
                isAllowed,
            });
            dispatch(this.saveOpposingPitchersToStorage());
        };
    },
    setOpposingPitchersAllowedQuantity(boundaryName, quantity) {
        return (dispatch) => {
            dispatch({
                type: Const.OPPOSING_PITCHERS_SET_ALLOWED_QUANTITY,
                boundaryName,
                quantity,
            });
            dispatch(this.saveOpposingPitchersToStorage());
        };
    },
    saveOpposingPitchersToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('opposingPitchers', function (state) {
                    const {opposingPitchers} = state;

                    return opposingPitchers.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, OpposingPitchers);
